export default {
  tabs: {
    fiintradeStrategy: 'Chiến lược đầu tư của Fiintrade',
    canslimStrategy: 'Chiến lược CANSLIM',
    taStrategy: 'Chiến lược TA',
  },
  common: {
    industry: 'Thứ hạng trong ngành',
    group: 'Thứ hạng trong nhóm',
  },
  listFiintrade: {
    overview: 'TỔNG QUAN',
    value: 'ĐT GIÁ TRỊ',
    growth: 'ĐT TĂNG TRƯỞNG',
    momentum: 'ĐT ĐỘNG LỰC',
    vgm: 'VGM',
    leaders: 'CP DẪN ĐẦU',
  },
  listOverviewTable: {
    ticker: 'MÃ',
    roe: 'ROE(%)',
    roa: 'ROA(%)',
    pe: 'P/E',
    pb: 'P/B',
  },
  listValue: {
    timeRange: 'KHOẢNG THỜI GIAN',
    stockePicks: 'NHÓM CỔ PHIẾU',
    vnIndex: 'VN-INDEX',
  },
  value: {
    calculated: '*Tính toán dựa trên khoảng đầu tư ban đầu là 100,000,000 VND',
  },
  fiinTradeRankingsHeader: {
    rank: 'Thứ hạng',
    ticker: 'Mã',
    industry: 'Ngành',
    rankingHistory: 'Lịch sử Thứ hạng',
    ranking: 'Thứ hạng',
    size: 'Quy mô',
    profit: 'Lợi nhuận',
    cashflow: 'Dòng tiền',
    valuation: 'Định Giá',
    trading: 'Giao dịch',
    analysisCover: 'Tỷ lệ báo cáo Phân tích',
    allIndustries: 'Nhóm',
    marketCap: 'Vốn Hóa (Tỷ)',
    value: 'Value',
    growth: 'Growth',
    momentum: 'Momentum',
    vgm: 'VGM',
  },
  visNameHeader: 'Đầu Tư Giá Trị',
  gisNameHeader: 'Đầu Tư Tăng Trưởg',
  misNameHeader: 'Đầu Tư Đà Tăng Trưởng',
  VMGNameHeader: 'Đầu Tư Kết Hợp',
  lisNameHeader: 'Đầu Tư Cổ phiếu Dẫn Đầu',
  highNameHeader: 'CỔ PHIẾU ĐẠT THỨ HẠNG CAO VÀ ĐIỂM A TRONG CHIẾN LƯỢC VALUE',
  growthNameHeader: 'THỨ HẠNG VÀ ĐIỂM ĐẦU TƯ TĂNG TRƯỞNG CAO',
  momentumNameHeader: 'THỨ HẠNG VÀ ĐIỂM ĐẦU TƯ ĐỘNG LỰC CAO',
  vmgNameHeader: 'THỨ HẠNG VÀ ĐIỂM ĐẦU TƯ KẾT HỢP CAO',
  leaderNameHeader: 'THỨ HẠNG CAO TRONG NGÀNH/ NHÓM CỔ PHIẾU',
  titleChart: 'TĂNG TRƯỞNG LŨY KẾ',
  titleLegendChartValue: 'Danh sách cổ phiếu theo Chiến lược đầu tư Giá Trị',
  titleLegendChartGrowth:
    'Danh sách cổ phiếu theo Chiến lược đầu tư Tăng Trưởng',
  titleLegendChartMomentum:
    'Danh sách cổ phiếu theo Chiến lược đầu tư Đà Tăng Trưởng',
  titleLegendChartVMG: 'Danh sách cổ phiếu theo Chiến lược đầu tư Kết Hợp',
  titleLegendChartLeaders:
    'Danh sách cổ phiếu theo Chiến lược đầu tư Cổ phiếu Dẫn Đầu',
  tooltipValue: 'Danh sách cổ phiếu theo Chiến lược đầu tư Giá Trị: ',
  tooltipGrowth: 'Danh sách cổ phiếu theo Chiến lược đầu tư Tăng Trưởng: ',
  tooltipMomentum: 'Danh sách cổ phiếu theo Chiến lược đầu tư Tăng Trưởng: ',
  tooltipVMG: 'Danh sách cổ phiếu theo Chiến lược đầu tư Kết Hợp: ',
  tooltipLeaders:
    'Danh sách cổ phiếu theo Chiến lược đầu tư Cổ phiếu Dẫn Đầu: ',
  tooltipVnIndex: 'VN-INDEX: ',
  return: 'Lợi tức',
  vnIndex: 'VN-INDEX',
  million: 'Triệu VND',
  vis: 'VIS',
  gis: 'GIS',
  mis: 'MIS',
  vmg: 'VMG',
  lis: 'LIS',
  strCalculated:
    '*Tính toán trên cơ sở lợi suất trung bình của các cổ phiếu được khuyến nghị (tích lũy trong vòng hơn 10 năm)',
  topFiveLeader: 'Top 5 Đầu Ngành',
  topFiveValue: 'Top 5 Giá Trị',
  topFiveGrowth: 'Top 5 Tăng Trưởng',
  topFiveMomentum: 'Top 5 Đà Tăng Trưởng',
  AllIndustries: 'Toàn Ngành',
  year: 'năm',
  years: 'năm',
  oneYear: 'năm',
};
